import { Card } from "react-bootstrap";
import styled from "styled-components";

export const Cover = styled.div`
  background-size: cover;
  background-position: center center;
  height: 50vh;
`;

export const BorderCard = styled(Card)`
  background-color: var(--gray-800);
`;
